import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const en = require('./language_packs/english.json');
const no = require('./language_packs/norwegian.json');
const de = require('./language_packs/german.json');
const se = require('./language_packs/swedish.json');
// const jp = require('./language_packs/jp.json')

enum LocaleEnum {
    no = 'no',
    en = 'en',
    de = 'de',
    se = 'se',
    // jp: "jp"
}

const messages = {
    en,
    no,
    de,
    se,
    // jp: jp
};

const i18n = new VueI18n({
    locale: 'en',
    messages,
});

export { i18n, LocaleEnum };
